// Temporary localStorage solution until backend is deployed
const PROFILES_KEY = 'csm_profiles';

function getProfiles() {
  try {
    return JSON.parse(localStorage.getItem(PROFILES_KEY) || '{}');
  } catch {
    return {};
  }
}

function saveProfiles(profiles) {
  localStorage.setItem(PROFILES_KEY, JSON.stringify(profiles));
}

export async function getProfileByEmail(email) {
  // Simulate async for consistency
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      const profiles = getProfiles();
      const profile = profiles[email.toLowerCase()];
      if (profile) {
        resolve(profile);
      } else {
        reject(new Error('Profile not found'));
      }
    }, 100);
  });
}

export async function upsertProfile(profile) {
  if (!profile?.email) throw new Error('Email required');
  
  // Simulate async for consistency
  return new Promise((resolve) => {
    setTimeout(() => {
      const profiles = getProfiles();
      const updatedProfile = {
        ...profile,
        email: profile.email.toLowerCase(),
        updatedAt: new Date().toISOString()
      };
      profiles[updatedProfile.email] = updatedProfile;
      saveProfiles(profiles);
      resolve(updatedProfile);
    }, 100);
  });
} 